var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"unpack_workspace"}},_vm._l((_vm.packs),function(pack){return _c('Pack',{key:pack.identity,attrs:{"pack":pack,"current_pack":_vm.current_pack,"all_packs":_vm.all_packs}})}))}
var staticRenderFns = []

export { render, staticRenderFns }